import React, { useState, useEffect, useContext } from 'react';
import BaseTable from 'components/UI/BaseTable';
import PropTypes from 'prop-types';
import { Button } from 'reactstrap';
import { headerOperation, cellOperation, cellNumOperation } from 'helpers/tables';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHistory, faUpload, faComments } from '@fortawesome/free-solid-svg-icons';
import SmallInfoTable from 'components/shared/SmallInfoTable';
import { get } from 'helpers/requests';
import { BASE_URL, API } from 'CONST';
import ModalHistorialRating from './posicionDeudorHistorialRating';
import ModalHistorialTecho from './posicionDeudorHistorialTecho';


const PosicionDeudorInfoTable = ( {datos, monedaAsegurada, modalCerrado} ) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isTechoModalOpen, setIsTechoModalOpen] = useState(false);
  const [currentRating, setCurrentRating] = useState(null);

  // El rating se lee desde BurosHub (solo lectura); se edita en BurosHub
  const fetchCurrentRating = () => {
    if (!datos?.rut) return;
    get(`${BASE_URL}${API.ratingBuroshub}/?rut=${encodeURIComponent(datos.rut)}`)
      .then(response => {
        setCurrentRating(response && response.length > 0 ? response[0] : null);
      })
      .catch(error => {
        console.error('Error al obtener el rating:', error);
        setCurrentRating(null);
      });
  };
  
  useEffect(() => {
    if (datos?.rut) {
      fetchCurrentRating();
    }
  }, [datos?.rut, modalCerrado]);
  
  const handleHistorialRatingClick = () => {
    setIsModalOpen(!isModalOpen);
  };

  const handleHistorialTechoClick = () => {
    setIsTechoModalOpen(!isTechoModalOpen);
  };
  
  const cumuloDisponible = (
    datos &&
    datos.techo_vigente &&
    datos.techo_vigente - datos.linea_vigente
  ) || 0;
  
  const datosColumns = [
    {
      tipo: `Techo vigente (${monedaAsegurada})`,
      credito: (
        <div className="d-flex align-items-center justify-content-end">
          <span style={{ 
            color: 'var(--orsan-green)', 
            fontWeight: '600',
            marginRight: '15px'
            }}
          >
            {datos.techo_vigente || '-'}
          </span>
          <Button
            color="link"
            size="sm"
            onClick={handleHistorialTechoClick}
            style={{ padding: '0 5px', color: '#6c757d' }}
            title="Ver historial de techo vigente"
          >
            <FontAwesomeIcon icon={faHistory} />
          </Button>
        </div>
      ),
    },
    {
      tipo: 'Lineas/Cúmulos vigentes',
      credito: datos.linea_vigente || 0,
    },
    {
      tipo: 'Cúmulo disponible',
      credito: cumuloDisponible || '-',
    },
    {
      tipo: 'Ventas declaradas vigentes',
      credito: '-'
    },
    {
      separator: "Información Complementaria"
    },
    {
      tipo: 'Rating',
      credito: (
        <div className="d-flex align-items-center justify-content-end">
          <span style={{ 
            color: 'var(--orsan-green)', 
            fontWeight: '600',
            marginRight: '15px'
            }}
          >
            {currentRating?.valor || '-'}
            {currentRating?.intervalo_nota && (
              <small className="text-muted" style={{ fontWeight: 400, marginLeft: '6px' }}>
                ({currentRating.intervalo_nota})
              </small>
            )}
          </span>
          <Button
            color="link"
            size="sm"
            onClick={handleHistorialRatingClick}
            style={{ padding: '0 5px', color: '#6c757d' }}
            title="Ver historial de ratings"
          >
            <FontAwesomeIcon icon={faHistory} />
          </Button>
        </div>
      ),
    }
  ];

  
  const columns = [
    {
      accessor: 'tipo'
    },
    {
      title: `Seguro de crédito (${monedaAsegurada})`,
      accessor: "credito",
      color: "var(--orsan-green)"
    },
    {
      title: `Garantías (${monedaAsegurada})`,
      accessor: "garantia",
      color: "var(--orsan-blue)"
    },
  ];
  
  return (
    <>
      <div className="mt-2">
        <SmallInfoTable
          title="Cúmulos deudor" 
          columns={columns}
          data={datosColumns}
          className=""
        />

      </div>
      
      <ModalHistorialRating
        isOpen={isModalOpen}
        toggle={handleHistorialRatingClick}
        rut={datos?.rut}
      />

      <ModalHistorialTecho
        isOpen={isTechoModalOpen}
        toggle={handleHistorialTechoClick}
        organizationId={datos?.organization_id}
      />
    </>
  );
};

PosicionDeudorInfoTable.propTypes = {
  datos: PropTypes.shape({
    techo_vigente: PropTypes.number,
    linea_vigente: PropTypes.number,
    organization_id: PropTypes.number,
    rut: PropTypes.string
  }).isRequired,
  monedaAsegurada: PropTypes.string.isRequired,
  modalCerrado: PropTypes.bool,
};
PosicionDeudorInfoTable.defaultProps = {
  modalCerrado: false,
};

export default PosicionDeudorInfoTable;
